import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule, provideZoneChangeDetection } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ConnectionInterceptor,
  ErrorInterceptor,
  TokenInterceptor,
} from '@core/interceptors';
import { environment } from '../environments/environment';
import { ReactiveFormsModule } from '@angular/forms';
import { NotFoundComponent } from './view/not-found/not-found.component';
import { provideNgxMask } from 'ngx-mask';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  provideFirestore,
  initializeFirestore,
  getFirestore,
} from '@angular/fire/firestore';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';

@NgModule({
  declarations: [AppComponent, NotFoundComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatIconModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConnectionInterceptor,
      multi: true,
    },
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false },
    },
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection(),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => {
      const fireApp = getApp();
      return initializeFirestore(fireApp, {
        ignoreUndefinedProperties: true,
      });
    }),
  ],
})
export class AppModule {
  private icons = [
    'app_scheduler',
    'app_small_group',
    'app_average',
    'app_completed_calendar',
    'app_group',
    'app_csv',
    'app_arrow_right',
    'app_out',
    'app_arrow_left',
    'app_slow_connection_icon',
    'app_file',
    'app_note',
    'app_not_found',
    'app_numbers',
  ];

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {
    this.icons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(
        icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `/assets/svg/${icon}.svg`,
        ),
      );
    });
  }
}
